import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Buildings, Package, TicketIcon, CurrencyDollar, CheckCircle, Prohibit } from "@phosphor-icons/react";

const brl = (v) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);

function Metric({ label, value, icon: Icon, tone = "default" }) {
  const tones = {
    default: "bg-white border-[#E5E5E0]",
    good: "bg-white border-[#0F4C3A]",
    warn: "bg-white border-[#D97706]",
    danger: "bg-white border-[#DC2626]",
  };
  return (
    <div className={`p-5 border ${tones[tone]} shadow-brutal`}>
      <div className="flex items-start justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.25em] font-semibold text-[#5C5C59]">{label}</div>
          <div className="mt-3 text-3xl font-black tracking-tighter text-[#1A1A1A]">{value}</div>
        </div>
        <div className="h-10 w-10 bg-[#F7F7F5] border border-[#E5E5E0] flex items-center justify-center">
          <Icon size={20} weight="duotone" className="text-[#0F4C3A]" />
        </div>
      </div>
    </div>
  );
}

export default function MasterDashboard() {
  const [m, setM] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/master/metrics").then((r) => setM(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-8 max-w-6xl">
      <div className="mb-8">
        <p className="text-xs font-semibold tracking-[0.3em] uppercase text-[#0F4C3A]">Painel Master</p>
        <h1 className="text-4xl font-black tracking-tighter text-[#1A1A1A] mt-1">Visão geral</h1>
        <p className="text-sm text-[#5C5C59] mt-2">Métricas em tempo real da sua operação.</p>
      </div>

      {loading ? (
        <div className="text-sm text-[#5C5C59]">Carregando métricas…</div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="master-metrics-grid">
            <Metric label="Receita mensal (MRR)" value={brl(m.mrr)} icon={CurrencyDollar} tone="good" />
            <Metric label="Empresas ativas" value={m.companies_active} icon={CheckCircle} tone="good" />
            <Metric label="Empresas bloqueadas" value={m.companies_blocked} icon={Prohibit} tone={m.companies_blocked > 0 ? "danger" : "default"} />
            <Metric label="Total de empresas" value={m.companies_total} icon={Buildings} />
            <Metric label="Planos cadastrados" value={m.plans_total} icon={Package} />
            <Metric label="Chamados de suporte" value={m.support_open} icon={TicketIcon} tone={m.support_open > 0 ? "warn" : "default"} />
          </div>

          <div className="mt-10 p-6 bg-[#0F4C3A] text-white shadow-brutal">
            <p className="text-[10px] uppercase tracking-[0.3em] font-semibold text-[#22A882]">Próximos passos</p>
            <h3 className="text-2xl font-bold tracking-tight mt-2 max-w-xl">
              Cadastre um plano e crie sua primeira empresa cliente.
            </h3>
            <p className="text-sm text-[#c8d5cf] mt-2 max-w-xl">
              Use o menu lateral para configurar planos com limites de atendentes e conexões, depois cadastre empresas atribuindo o plano correto.
            </p>
          </div>
        </>
      )}
    </div>
  );
}
